const list = [
  'Kaunist jõuluaega meie perelt!',
  'Jõulud – aasta piinlikuim püha. Veeda vängelt!',
  'Piinlikke jõulusoove siitpoolt sood!',
  'Tõmba pidurit, kui pühad liiga kangeks lähevad!',
  'Ihaldame, et oleksid jõuludel meiega!',
  'Häid pühi! P.S. Kõik on fotograafi süü...',
  'Meie laud on kaetud, loodame, et ka sinu!',
  'Harry ja Marv meid ei kõiguta! Kauneid pühi!',
  'Olgu jõulumees teiegi pere vastu helde!',
  'Jõulupühad – loomastumise protsent on kõrge! Rahu!',
  'Kui sööd üle, söö üle rahust ja armastusest!',
  'Jõulud on võtmise, mitte andmise aeg!',
  'Stiilseid jõule, kambajõmm!',
  'Pumpa enda pühadesse veidi stiili! Jõulukallid!',
  'Unusta Hurghada – Jõuluvana põlv on aasta soojeim koht!',
  'Soovime sulle armastust üle kogu maa!',
  'Jõulud veeda ka sina pere seltsis!',
  'Lapsed on ikka elu õied... Kaunist jõuluaega kõigile!',
  'Jõuluhullus on vallutanud Eesti!',
  'Soovime mitte liiga pühalikke pühi!',
  'Ära unusta pohlamoosi kõrvale verivorsti võtta!',
  'Tasa, tasa, jõulukellad ajukahjustusi rajavad!',
  'Läbi lume sahiseva tulin ja näete nüüd ise!',
  'Parim koos Karavani jõululauludega!',
  'Ja kui maailm näeb kaunist und, sajab väljas ikka valget lund.',
  'Särab kuusk ja särab tuba, lapsed rõõmsad kuuse ees.',
  'Soovime seapraadi ja glögi, millel on ka kraadi!',
  'Jõulu ja jaksu!'
]

const length = list.length
let random = 1
let lastRandom = 0

const getRandomQuote = () => {
  lastRandom = random
  random = Math.floor(Math.random() * length)

  if (lastRandom === random) return getRandomQuote()
  else return list[random]
}

export const getQuote = getRandomQuote

// Quotes as images 🤦‍♂️
let randomImg = 1
let lastRandomImg = 0
const amountOfQuoteImages = 41
const quoteLocation = nr =>
  `https://firebasestorage.googleapis.com/v0/b/tank-xmas.appspot.com/o/quotes%2F${nr}.png?alt=media`

export const getQuoteImg = () => {
  lastRandomImg = randomImg
  randomImg = Math.floor(Math.random() * amountOfQuoteImages) + 1

  if (lastRandomImg === randomImg || typeof randomImg !== 'number') return getQuoteImg()
  else return quoteLocation(randomImg)
}
